import React from 'react';

import UserContainer from './UserContainer';
import { UserDetail } from './UserDetail';

const UserPage: React.FC = () => (
    <UserContainer.Provider>
        <UserDetail/>
    </UserContainer.Provider>
);
export default UserPage;
